<template>
    <div class="creat-memorial">
        <div class="form-group">
            <div class="form-item">
                <div class="left-label">逝者姓名</div>
                <input class="form-input" v-model.trim="submitData.deadName"  type="text" placeholder="请输入逝者姓名（多个逝者逗号隔开）" >
            </div>
            <div class="form-item">
                <div class="left-label">生辰</div>
                <DatePicker ref="birthDate" :value="submitData.birthDate" @on-change="dateChange($event,'birthDate')"  type="date"  placeholder="请选择生辰日期"  style="width: 300px"></DatePicker>
            </div>
            <div class="form-item">
                <div class="left-label">逝世</div>
                <DatePicker ref="deathDate" :value="submitData.deathDate" @on-change="dateChange($event,'deathDate')" type="date"  placeholder="请选择逝世日期"  style="width: 300px"></DatePicker>
            </div>
            <div class="form-item" >
                <div class="left-label">性别</div>
                <RadioGroup  v-model="submitData.sex" >
                    <Radio size="large" style="width: 100px"  :label="item.value" :key="index" v-for="(item,index) in radioGroup.sexList">
                        <span>{{item.name}}</span>
                    </Radio>
                </RadioGroup>
            </div>
            <div class="form-item area" >
                <div class="left-label">地区</div>
                <div class="current-select-area" v-if="selectAreaName && !hasSelect">当前选择的地区：{{selectAreaName}}</div>
                <cityAreaSelect ref="cityArea" @areaChange="areaChange"></cityAreaSelect>
            </div>
            <div class="form-item">
                <div class="left-label">主照片</div>
                <uploadFiles :leadImgList="mainLeadImgList" ref='mainImg' :onlyOne="onlyOne" :multiple="isMultiple" type="主照片" @updateTotalImgList="updateImgList($event,'main')"></uploadFiles>
            </div>
            <div class="form-item">
                <div class="left-label">生活照</div>
                <uploadFiles :leadImgList="lifeLeadImgList" ref='lifeImg'  type="生活照"  @updateTotalImgList="updateImgList($event,'life')"></uploadFiles>
            </div>
            <div class="form-item">
                <div class="left-label">纪念馆</div>
                <RadioGroup   v-model="submitData.templateId">
                    <Radio size="large" style="width: 100px" :label="item.id" :key="index" v-for="(item,index) in radioGroup.memorialList">
                        <span>{{item.name}}</span>
                    </Radio>
                </RadioGroup>
            </div>
            <div class="form-item ">
                <div class="left-label">生平简介</div>
                <textarea style="padding: 5px" name="" id="" cols="50" v-model="submitData.life"></textarea>
            </div>
            <Button v-if="userMemorialId" class="created-btn" @click="submitMemorial('modify')" size="large" type="primary" style="width: 300px">修改</Button>
            <Button v-else class="created-btn" @click="submitMemorial('create')" size="large" type="primary" style="width: 300px">创建</Button>
        </div>
    </div>
</template>

<script>
    var self ;
    import uploadImg from '../../components/uploadImg'
    import uploadFiles from '../../components/uploadFiles'
    import cityAreaSelect from '../../components/city-area-select'
    import api from '../../api/api'
    import storage from '../../stroage'
    import {mapState,mapMutations} from 'vuex'
    function initSubmitData() {
        return {
            deadName:'',
            birthDate:'',
            deathDate: '',
            sex:'',
            areaCode:"",
            life:'',
            templateId:'',
            image:'',
            images:[],
            albums:[],
        }
    }
    export default {
        components: {
            uploadImg,
            uploadFiles,
            cityAreaSelect
        },
        computed:{
            ...mapState(['userMemorialId']),
        },
        data(){
            return{
                birthDate:new Date(),
                onlyOne:true,
                isMultiple:false,
                radioGroup:{
                    memorialList:[{
                        name:'海',
                        id:'1'
                    },{
                        name:'菊',
                        id:'2'
                    },{
                        name:'兰',
                        id:'3'
                    },{
                        name:'梅',
                        id:'4'
                    },{
                        name:'竹',
                        id:'5'
                    }],
                    sexList:[]
                },
                submitData:initSubmitData(),
                checkData:{
                    deadName:{
                        msg:'逝者姓名必须要填写'
                    },
                    birthDate:{
                        msg:'逝者生日必须要填写'
                    },
                    deathDate: {
                        msg:'逝者离世日必须要填写'
                    },
                    sex:{
                        msg:'逝者性别必须要选择'
                    },
                    templateId:{
                        msg:'纪念馆类型必须要选择'
                    },
                    image:{
                        msg:'主照片必须要上传',
                    },
                    areaCode:{
                        msg:'省份城市需要上传'
                    }
                },
                mainLeadImgList:[],
                lifeLeadImgList:[],
                selectAreaName:'',
                hasSelect:false
            }
        },
        activated(){
            // console.log(this.$store.state);
            // console.log(this.$store.state.userMemorialId);
            self = this;
            this.getSexs()
            if(this.userMemorialId){
                this.getMemorialDetail()
                this.getImgList()
            }
        },
        methods:{
            ...mapMutations(['saveUserMemorialId']),
            parseFormData(data){
                this.submitData = {
                    deadName:data.deadName,
                    birthDate:data.birthDate,
                    deathDate: data.deathDate,
                    sex:data.sex,
                    areaCode:data.areaCode,
                    life:data.life,
                    templateId:data.templateId,
                    image:data.headImage
                }
                this.selectAreaName = data.areaCodeName;
                this.mainLeadImgList = [{url:data.headImage}]
            },
            getImgList() {
                var imgList = []
                var images = []
                if(!this.userMemorialId)return
                api.getAlbumList({memorialId:this.userMemorialId}).then(res =>{
                    for(let i=0;i<res.rows.length;i++){
                        imgList.push({url:res.rows[i].picUrl})
                        images.push(res.rows[i].picUrl)
                    }
                    self.lifeLeadImgList = imgList
                    self.submitData.images = images
                    // console.log('回显的生活照列表：---',self.submitData)
                }).catch(error =>{
                    this.$Message.error(error.info)
                })
            },
            getMemorialDetail(){
                api.getMemorialDetail({memorialId:this.userMemorialId}).then(res=>{
                    self.parseFormData(res)
                    // console.log(res)
                }).catch(error =>{
                    this.$Message.error('详情数据获取错误')
                })
            },
            initPluginForm(){
                this.$refs.birthDate.handleClear()
                this.$refs.deathDate.handleClear()
                this.$refs.cityArea.handleClear()
                this.$refs.mainImg.clearAllImg()
                this.$refs.lifeImg.clearAllImg()
            },
            //选择地区
            areaChange(data){
                // console.log('areaChange:',data)
                this.submitData.areaCode = data.id;
                this.hasSelect = true
            },
            updateImgList(items,key){
                if(key=='life'){
                    let list = []
                    if(items.length==0){
                        this.submitData.albums = [];
                    }else {
                        items.forEach(function (item) {
                            list.push({
                                picUrl:item.url,
                                filePath:item.privateKey
                            })
                        })
                        self.submitData.albums = list
                    }
                }
                if(key=='main'){
                    if(items.length==0){
                        this.submitData.image = '';
                        this.submitData.filePath = '';
                    }else {
                        this.submitData.image = items[0].url;
                        this.submitData.filePath = items[0].privateKey;
                    }
                }
            },
            //当前所有的id
            checkFilesId(item,key){
                // console.log('item',item)
                // console.log('key',key)
                if(key=='main'){
                    if(item.type=='add'){
                        this.submitData.image = item.ids[0].url;
                    }else if(item.type=='del'){
                        this.submitData.image = '';
                    }
                }
            },
            //日期选择回调
            dateChange(e,key){
                this.submitData[key] = e;
            },
            //获取性别列表
            getSexs(){
                storage.getSexs().then(res =>{
                    self.radioGroup.sexList = res;
                })
            },
            checkSubmitData(){
                var flag = true;
                var i;
                for(i in this.checkData){
                    if(!this.submitData[i]){
                        self.$Message.error(`${this.checkData[i].msg}`)
                        flag = false
                        break
                    }
                }
                return flag
            },

            submitMemorial(key){
                if(!this.checkSubmitData())return
                let data =  this.submitData;
                if(key=='modify'){
                    Object.assign(data,{memorialId:this.userMemorialId})
                }
                console.log(data)
                api.createdMemorial(data).then(res =>{
                    if(res.memorialId){
                        self.saveUserMemorialId(res.memorialId)
                    }
                    if(key=='create'){
                        self.$Message.success('纪念馆创建成功')

                        // this.initPluginForm();
                        // this.submitData = initSubmitData()
                    }else{
                        self.$Message.success('纪念馆修改成功')
                    }
                }).catch(error =>{
                    console.log(error)
                    if(key=='create'){
                        self.$Message.success('纪念馆创建失败')
                    }else{
                        self.$Message.success('纪念馆修改失败')
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .creat-memorial{
        padding: 20px 70px;
        .form-group{
            font-size: 16px;
            color: #333;
            margin-bottom: 50px;
            .form-group-name{
                text-align: left;
                font-size: 18px;
                border-bottom: 1px solid #e5e5e5;
                padding-bottom: 20px;
                margin-bottom: 30px;
            }
            .form-item{
                overflow: hidden;
                border-bottom: 1px solid #e5e5e5;
                padding-bottom: 10px;
                margin-bottom: 10px;
                line-height: 40px;
                padding-left: 100px;
                text-align: left;
                &.area{
                    overflow: inherit;
                }
                .left-label{
                    float: left;
                    width: 100px;
                    margin-left: -100px;
                    text-align: left;
                }
                .form-input{
                    float: left;
                    border: none;
                    width: 300px;
                    height: 40px;
                    padding: 4px;
                    &.textarea{
                        height: auto;
                    }
                }
                .edit{
                    color: #009DE9;
                    float: right;
                    &:hover{
                        cursor: pointer;
                    }
                }
                textarea{
                    border: none;
                }
            }
        }
        .created-btn{
            margin-top: 20px;
            background-color: #009DE9;
        }
    }
</style>
